module.exports = __webpack_public_path__ + "img/rinsizeMeasurement.ac41137.webp";